const formatDate = (date: string) => {
  const handleDate = new Date(date);

  const dateTimeFormat = new Intl.DateTimeFormat('pt', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  });
  return dateTimeFormat.format(handleDate);
};

export { formatDate };
